import React, { lazy, Suspense } from 'react';
import LoadingIndicator from '@wix/da-ds/pkg/LoadingIndicator';
import ErrorBoundary from '@wix/da-react-context/pkg/ErrorBoundary';
import { useIsMounted } from '@wix/da-hooks/pkg/useIsMounted';
import useI18next from '../../hooks/useI18next';
import retry from '@wix/da-shared-react/pkg/utils/webpack/chunkRetry';
const LoadableRedux = /*#__PURE__*/ lazy(()=>retry(()=>import(/* webpackChunkName: "muro_editor" */ '../../redux/MuroModuleLoader')));
const LoadableModals = /*#__PURE__*/ lazy(()=>retry(()=>import(/* webpackChunkName: "muro_editor" */ '../Modals')));
const I18NextLoader = ()=>{
    useI18next();
    return null;
};
/**
 * This is a wrapper that should be used in your preset
 */ const MuroEditorLoadableWrapper = ({ children, fallback })=>{
    const isMounted = useIsMounted();
    if (!isMounted) {
        return null; // never SSR
    }
    return /*#__PURE__*/ React.createElement(ErrorBoundary, {
        debugComponent: "MuroEditorLoadableWrapper"
    }, /*#__PURE__*/ React.createElement(Suspense, {
        fallback: fallback !== null && fallback !== void 0 ? fallback : /*#__PURE__*/ React.createElement(LoadingIndicator, {
            view: 'llama'
        })
    }, /*#__PURE__*/ React.createElement(I18NextLoader, null), /*#__PURE__*/ React.createElement(LoadableRedux, null), /*#__PURE__*/ React.createElement(LoadableModals, null), children));
};
MuroEditorLoadableWrapper.displayName = 'MuroEditorLoadableWrapper';
export default MuroEditorLoadableWrapper;

//# sourceMappingURL=MuroEditorLoadableWrapper.js.map